import { render, staticRenderFns } from "./ChartStatisticsConsultations.vue?vue&type=template&id=8bcc47a8&scoped=true"
import script from "./ChartStatisticsConsultations.vue?vue&type=script&lang=js"
export * from "./ChartStatisticsConsultations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcc47a8",
  null
  
)

export default component.exports